<template>
  <v-row>
    <v-col cols="12" md="12" class="pa-2 pt-0 d-md-flex">
      <span class="font-weight-bold primary--text text-h6 pl-1">
        {{ $t(title) }}
      </span>
      <slot name="add"> </slot>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'i-prepare_textarea',
  props: {
    title: {
      type: String,
      default: '제목없음'
    }
  }
}
</script>
<style scoped></style>
